import { render, staticRenderFns } from "./CockpitMatryoshkaItemLabelTab.vue?vue&type=template&id=684704da&scoped=true"
import script from "./CockpitMatryoshkaItemLabelTab.vue?vue&type=script&lang=js"
export * from "./CockpitMatryoshkaItemLabelTab.vue?vue&type=script&lang=js"
import style0 from "./CockpitMatryoshkaItemLabelTab.vue?vue&type=style&index=0&id=684704da&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "684704da",
  null
  
)

export default component.exports